enum KeyboardKeys {
  ENTER = "Enter",
  BACKSPACE = "Backspace",
  ESCAPE = "Escape",
  TAB = "Tab",
  SPACE = " ",
  ARROW_UP = "ArrowUp",
  ARROW_DOWN = "ArrowDown",
  ARROW_LEFT = "ArrowLeft",
  ARROW_RIGHT = "ArrowRight",
  DELETE = "Delete",
}

export default KeyboardKeys;
